import { render } from "./AdminUserManagementDashboard.vue?vue&type=template&id=00d424e8&scoped=true"
import script from "./AdminUserManagementDashboard.vue?vue&type=script&lang=js"
export * from "./AdminUserManagementDashboard.vue?vue&type=script&lang=js"

import "./AdminUserManagementDashboard.vue?vue&type=style&index=0&id=00d424e8&scoped=true&lang=css"

import exportComponent from "C:\\Users\\blake\\LREX-site\\lrex-site\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00d424e8"]])

export default __exports__